/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConsentDTO } from '../models/ConsentDTO';
import type { TempAndCarDTO } from '../models/TempAndCarDTO';
import type { TemporaryDataDTO } from '../models/TemporaryDataDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomTemporaryDataResourceService {
    /**
     * Confirm the new lead data
     * Confirmation of new lead data
     * @returns any OK
     * @throws ApiError
     */
    public static dataConfirmation({
        tempId,
        requestBody,
    }: {
        /**
         * The ID of new Lead
         */
        tempId: number,
        requestBody: ConsentDTO,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/temporary_data/dataConfirmation/{tempId}',
            path: {
                'tempId': tempId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TemporaryDataDTO OK
     * @throws ApiError
     */
    public static createTemporaryHsData({
        requestBody,
    }: {
        requestBody: TemporaryDataDTO,
    }): CancelablePromise<TemporaryDataDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/temporary_data/addTempData',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the temporary data dto requested
     * Retrieves the data dto of requested temporary lead
     * @returns TempAndCarDTO OK
     * @throws ApiError
     */
    public static getTemporaryDataDetails({
        tempId,
    }: {
        /**
         * The ID of the new temporary lead
         */
        tempId: number,
    }): CancelablePromise<TempAndCarDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/temporary_data/details/{tempId}',
            path: {
                'tempId': tempId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteTempData({
        leadMail,
    }: {
        /**
         * The mail of the new temporary lead to delete
         */
        leadMail: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/temporary_data/deleteTempData/{leadMail}',
            path: {
                'leadMail': leadMail,
            },
        });
    }
}
